<template>
  <div>
    <dashboard-navbar :routes="routes"></dashboard-navbar>
    <div class="content" @click="$sidebar.displaySidebar(false)">
      <div class="container-fluid mt-2">
        <card body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <div class="row d-flex justify-content-between px-2">
              <h2 class="mb-0">List Trainer's Profile</h2>
              <router-link :to="{ name: 'addTrainer' }" class="btn btn-brand-ar-vr">Add New Trainer</router-link>
            </div>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between mb-3">
              <div class="wrapper-select">
                <span>Show</span>
                <div class="select-row">
                  <el-select
                    class="select-primary pagination-select"
                    size="mini"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </div>
                <span>Row</span>
              </div>
              <div class="form-search">
                <base-input v-model="searchQuery" placeholder="Search Records" size="mini"></base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column"></el-table-column>
              <el-table-column min-width="200px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button @click.native="handleEdit($index, row)" type="edit-vr" size="sm">
                    <span>Edit</span>
                  </base-button>
                  <base-button @click.native="handleCourse($index, row)" type="detail-vr" size="sm">
                    <span>Detail Course</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                <span
                  v-if="selectedRows.length"
                >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllTrainer } from '@/services/trainer'
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '@/components';
import DashboardNavbar from '@/Layout/DashboardNavbar.vue';
import listTrainersMixin from './Mixins/listTrainersMixin'
import Fuse from "fuse.js";
import { mapActions, } from 'vuex'
export default {
  mixins: [listTrainersMixin],
  name: "ListTrainers",
  components: {
    BasePagination,
    DashboardNavbar,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      propsToSearch: ['name', 'npaidi', 'email', 'institute', 'profesi'],
      tableColumns: [
        {
          prop: 'name',
          label: 'FullName',
          minWidth: 180,
          sortable: true
        },
        {
          prop: 'npaidi',
          label: 'Npa ID',
          minWidth: 150,
          sortable: true
        },
        {
          prop: 'email',
          label: 'Email',
          minWidth: 280,
          sortable: true
        },
        {
          prop: 'institute',
          label: 'Institute',
          minWidth: 210,
          sortable: true
        },
        {
          prop: 'profesi',
          label: 'Profession',
          minWidth: 180,
          sortable: true
        },
      ],
      tableData: [],
      selectedRows: [],
      routes: [
        {
          name: "ListTrainers",
          alias: "List-Trainers"
        }
      ]
    };
  },
  methods: {
    ...mapActions('trainer', ['setSelectedTrainer']),
    handleEdit(index, row) {
      this.$router.push({ name: 'editTrainer', params: { id: row.id } })
    },
    handleCourse(index, row) {
      this.setSelectedTrainer(row)
      this.$router.push({ name: 'trainerCourses', params: { id: row.id } })
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    async getTrainer() {
      try {
        const { data } = await getAllTrainer()
        this.tableData = data
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      } catch (error) {
        if (error.code === 401) {
          this.$cookies.remove('CERT');
          this.$store.dispatch('auth/removeAuth');
          this.$router.replace({ name: "Login" })
          this.$notify({
            type: "danger",
            verticalAlign: "top",
            horizontalAlign: "center",
            closeOnClick: true,
            message: error.msg
          });
        } else {
          this.$notify({
            type: "danger",
            verticalAlign: "top",
            horizontalAlign: "center",
            closeOnClick: true,
            message: error
          });
        }
      }

    }
  },
  mounted() {
    this.getTrainer()
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/argon.scss";
.pagination-select {
  margin: 0 5px;
}
.wrapper-select {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .select-row {
    width: 75px;
    margin-right: 10px;
  }
}
</style>